<template>
  <section class="section-padding-gray">
    <h2 class="text-center">{{ $t('message.home.customer_reviews') }}</h2>
    <h2 class="text-center" style="color:#00ABC2;">{{ $t('message.home.professional_service') }}</h2>

    <div class="container">
      <div class="row">
        <div class="col-12 text-right">
          <router-link to="/reviews"  tag="a" class="text-primary-link">
            {{ $t('message.see_all') }} <i class="far fa-angle-right"></i>
          </router-link>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="owl-carousel owl-theme homepage">
            <div class="item" v-for="(item, index) in reviews" :key="index">
              <review-items :item="item"></review-items>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
import 'owl.carousel'
import axios from 'axios'
import reviewHelpers from '../../helpers/reviewHelpers'
import ReviewItems from './components/ReviewItems'

export default {
  name: 'ReviewByUser',
  components: { ReviewItems },
  data () {
    return {
      reviews: [],
      hasMoreLine: false
    }
  },
  methods: {
    conditionPageService (experienceId) {
      return reviewHelpers.conditionPageService(experienceId)
    },
    conditionWithParamId (reviewObj) {
      return reviewHelpers.conditionWithParamId(reviewObj)
    },
    cutText (value) {
      return reviewHelpers.cutText(value)
    },
    async initOwlCarousel () {
      await window.$('div.owl-carousel').owlCarousel({
        loop: true,
        margin: 30,
        responsiveClass: true,
        nav: true,
        autoplay: true,
        autoplayTimeout: 2000,
        autoplayHoverPause: true,
        navText: ['<i class="fas fa-chevron-circle-left"></i>', '<i class="fas fa-chevron-circle-right"></i>'],
        responsive: {
          0: {
            items: 1,
            nav: true,
            loop: true,
            dots: false
          },
          768: {
            items: 2,
            nav: true,
            loop: true,
            dots: false
          },
          1200: {
            items: 3,
            nav: true,
            loop: true
          }
        }
      })
      window.$('div.homepage div.owl-nav button.owl-prev').css({
        'width': '15px',
        'height': 'auto',
        'position': 'absolute',
        'top': '40%',
        'left': '0',
        'margin-left': '-25px',
        'display': 'block !important',
        'border': '0px solid black'
      }).addClass('no-focus')

      window.$('div.homepage div.owl-nav button.owl-next').css({
        'width': '15px',
        'height': 'auto',
        'position': 'absolute',
        'top': '40%',
        'right': '-25px',
        'display': 'block !important',
        'border': '0px solid black'
      }).addClass('no-focus')

      window.$('div.homepage div.owl-nav button.owl-next i, button.owl-prev i').css({
        'transform': 'scale(2, 2)',
        'color': '#ccc'
      })
    },
    async fetchReviews () {
      let { data } = await axios.get('get-reviews-from-user')
      if (!data.error) {
        this.reviews = data.professional_reviews
        this.$nextTick(() => {
          this.initOwlCarousel()
        })
      } else {
        console.error('Reviews cannot load : ' + data.message)
      }
    }
  },
  mounted () {
    this.fetchReviews()
  }
}
</script>

<style scoped lang="scss">

@import "~owl.carousel/dist/assets/owl.carousel.css";
@import "~owl.carousel/dist/assets/owl.theme.default.min.css";


</style>



// WEBPACK FOOTER //
// src/components/review/ReviewByUser.vue